import type { AnalysisRow } from "../shared/analysisListTypes";
import {
  normalizeSituacaoNomeApiMeritocracia,
  normalizeV2ListItemDates,
} from "../shared/analysisListUtils";

const inferSituacaoFromDates = (item: any): string => {
  if (item?.analiseConcluidaEm) return "Análise Concluída";
  if (item?.adequacaoSolicitadaEm && !item?.adequacaoRealizadaEm) {
    return "Adequação Pendente";
  }
  if (item?.enviadoPeloSindicatoEm) return "Documentação Enviada";
  return "Documentação Pendente";
};

export const mapSolicitacoesLegacyToAnalysisRows = (
  items: unknown[],
  ano = 2025,
): AnalysisRow[] => {
  if (!Array.isArray(items)) return [];

  return items.map((item: any, index) => {
    const datas = normalizeV2ListItemDates(item);
    const situacaoApi = item?.situacao?.nome || null;
    const situacaoFinal = situacaoApi
      ? normalizeSituacaoNomeApiMeritocracia(situacaoApi)
      : inferSituacaoFromDates(item);
    const idQuestionarioResposta = item?.idQuestionarioResposta ?? null;

    return {
      id: idQuestionarioResposta ?? index + 1,
      solicitacao: item?.solicitacao || "1ª Solicitação",
      situacao: situacaoFinal,
      envioDocumentacao: datas.enviadoPeloSindicatoEm,
      ultimaAtualizacao: datas.atualizadoPeloSindicatoEm,
      solicitacaoAdequacao: datas.adequacaoSolicitadaEm,
      adequacaoDocumentacao: datas.adequacaoRealizadaEm,
      conclusaoAnalise: datas.analiseConcluidaEm,
      ano,
      idQuestionarioResposta,
      idSindicato: item?.idSindicato ?? item?.sindicatoId ?? null,
      historicoHabilitado:
        !!idQuestionarioResposta && idQuestionarioResposta !== 0,
      cnpj: item?.cnpj ?? null,
      sigla: item?.sigla ?? null,
      rowKey: `a-legacy-${idQuestionarioResposta ?? index}-${ano}`,
    };
  });
};
